<template>
  <div id="app">
    <router-view></router-view>
    <yy-chatbot-view
      v-if="aiChatbotFlag"
      id="yy-chatbot-view"
      chat-config="{}"
      @chat-change="onchatChange"
    ></yy-chatbot-view>
  </div>
</template>
<script>
window.verifiyVm = null;
// 发送验证码人机交互弹窗
if (!document.getElementById("verifiyPannel")) {
  $("body").append('<div id="verifiyPannel"></div>');
  if ($("#verifiyPannel").slideVerify) {
    $("#verifiyPannel").slideVerify({
      mode: "pop",
      containerId: "mk_manage_login",
      beforeCheck: function() {},
      ready: function() {}, //加载完毕的回调
      success: function(params) {
        $("#verifiyPannel .mask").css("display", "none");
        verifiyVm.onSuccess(params);
      },
      error: function() {} //失败的回调
    });
  }
}
import { mapGetters } from "vuex";
export default {
  name: "app",
  data() {
    return {
      aiChatbotModule: [
        {
          name: "文章模块",
          router: "content/article/edit",
          chatbotId: "7496779904181387276",
          chatbotName: "AI文章助手",
          platform: "kouzi",
          stream: false,
          chatbotTips: [
            "提取文章TDK(标题、描述、关键字)简要信息",
            "提取文章匹配的行业、领域信息",
            "提取文章匹配的标签信息",
            "检查文章中错别字或语法错误信息"
          ],
          message: {
            hideMessage: "",
            requiredHideMessage: true,
            hideMessageError:
              "未检测到文章内容，确认正文内容是否包含文字，暂不支持解析图片"
          }
        },
        {
          name: "调查问卷",
          router: "content/questionnaire/edit",
          chatbotId: "7503373581645070386",
          chatbotName: "AI问卷助手",
          platform: "kouzi",
          stream: false,
          chatbotTips: [
            "生成公司财务数智化转型调查问卷",
            "对问卷题目进行优化或修改"
          ],
          message: {
            hideMessage: "",
            requiredHideMessage: false,
            hideMessageError: ""
          }
        },
        {
          name: "邮件",
          router: "market/email/add",
          chatbotId: "7537887749543018534",
          chatbotName: "AI邮件助手",
          platform: "kouzi",
          stream: false,
          chatbotTips: [
            "为邮件内容生成一个精准且具有吸引力的标题"
          ],
          message: {
            hideMessage: "未检测到邮件内容，确认邮件内容是否包含文字，暂不支持解析图片",
            requiredHideMessage: true,
            hideMessageError: ""
          }
        },
        // {
        //   name: "邮件",
        //   router: "market/email/template",
        //   chatbotId: "7537887749543018534",
        //   chatbotName: "AI邮件助手",
        //   platform: "kouzi",
        //   stream: false,
        //   chatbotTips: [
        //     "为邮件内容生成一个精准且具有吸引力的标题"
        //   ],
        //   message: {
        //     hideMessage: "未检测到邮件内容，确认邮件内容是否包含文字，暂不支持解析图片",
        //     requiredHideMessage: true,
        //     hideMessageError: ""
        //   }
        // }
      ],
      aiChatbotFlag: false
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  mounted() {
    if (sessionStorage.token != null) {
      this.$store.dispatch("login", sessionStorage.token);
    }
    //判断有没有参数
    var auth_code = this.getQueryString("auth_code");
    if (auth_code != null && auth_code.toString().length > 1) {
      window.location.href =
        "https://mk.yybip.com/" +
        (process.env.NODE_ENV === "production" ? "manage" : "tmanage_dev") +
        "/" +
        "#/weixincallback?auth_code=" +
        auth_code +
        "&expires_in=" +
        this.getQueryString("expires_in");
    }
    window.addEventListener("message", event => {
      if (event.data.type == "route") {
        this.$router.push(event.data.params.path);
      }
    });
    // 监听AI聊天机器人事件
    this.listenAiChatbotEvents();
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    onchatChange(chatInfo) {
      this.$bus.$emit("yyChatbotCall", chatInfo);
    },
    // 监听子组件发送的显示/隐藏AI聊天机器人事件
    listenAiChatbotEvents() {
      this.$bus.$on('showAiChatbot', (moduleName) => {
        this.aiChatbotFlag = true;
        this.setAiChatbotConfig(moduleName);
      });
      this.$bus.$on('hideAiChatbot', () => {
        this.aiChatbotFlag = false;
      });
    },
    setAiChatbotConfig(moduleName) {
      // 查找匹配的模块配置
      const moduleConfig = this.aiChatbotModule.find(item => item.name === moduleName);
      if (moduleConfig) {
        this.$nextTick(() => {
          yychatbot.config({
            token: sessionStorage.token,
            width: "400px",
            height: "calc(100% - 90px)",
            serviceId: "mk-tenant",
            serviceName: "市场营销平台-租户端",
            chatbot: {
              id: moduleConfig.chatbotId,
              name: moduleConfig.chatbotName,
              platform: moduleConfig.platform,
              stream: moduleConfig.stream,
              tips: moduleConfig.chatbotTips
            },
            user: {
              id: this.user.id,
              yhtId: "",
              name: this.user.name
            },
            message: {
              hideMessage: moduleConfig.message.hideMessage,
              requiredHideMessage: moduleConfig.message.requiredHideMessage,
              hideMessageError: moduleConfig.message.hideMessageError
            }
          });
        });
      }
    }
  }
};
</script>
<style lang="scss">
@import "./assets/css/common.scss";
@import "./assets/css/mixin.scss";
@import "./assets/css/theme/variable.scss";
@import "./assets/css/theme/theme.scss";
/* 修复验证面板图标字体被 icomoon 覆盖的问题 */
.iconfont {
  font-family: "iconfont" !important;
}
#app {
  height: 100%;
}
</style>
